import React, { useState } from 'react';
import { PageTooltip } from '../components/TooltipSystem';
import {
  BarChart2, DollarSign, Crown, Gift, TrendingUp, Clock, Users,
  ClipboardList, Activity, PieChart as PieIcon, Radio, Target, UserPlus, Star,
} from 'lucide-react';

import { OverviewTab } from '../components/analytics/OverviewTab';
import { RevenueTab } from '../components/analytics/RevenueTab';
import { SegmentsTab } from '../components/analytics/SegmentsTab';
import { CustomersTab } from '../components/analytics/CustomersTab';
import { RewardsAnalyticsTab } from '../components/analytics/RewardsTab';
import { ReferralTab } from '../components/analytics/ReferralTab';
import { HoursTab } from '../components/analytics/HoursTab';
import { OperatorsTab } from '../components/analytics/OperatorsTab';
import { RfmTab } from '../components/analytics/RfmTab';
import { AuditTab } from '../components/analytics/AuditTab';
import { ChannelsTab } from '../components/analytics/ChannelsTab';
import { CampaignsTab } from '../components/analytics/CampaignsTab';
import { AcquisitionTab } from '../components/analytics/AcquisitionTab';
import { ReviewsTab } from '../components/analytics/ReviewsTab';

const TABS = [
  { id: 'overview', label: 'Overview', icon: BarChart2 },
  { id: 'acquisition', label: 'Acquisizione', icon: UserPlus },
  { id: 'channels', label: 'Canali', icon: Radio },
  { id: 'campaigns', label: 'Campagne', icon: Target },
  { id: 'revenue', label: 'Visite & Ricavi', icon: DollarSign },
  { id: 'segments', label: 'Segmentazione', icon: PieIcon },
  { id: 'customers', label: 'Clienti', icon: Crown },
  { id: 'rewards', label: 'Premi', icon: Gift },
  { id: 'referral', label: 'Referral', icon: TrendingUp },
  { id: 'reviews', label: 'Recensioni', icon: Star },
  { id: 'hours', label: 'Orari', icon: Clock },
  { id: 'operators', label: 'Operatori', icon: Users },
  { id: 'rfm', label: 'RFM', icon: Activity },
  { id: 'audit', label: 'Registro', icon: ClipboardList },
];

const TAB_COMPONENTS = {
  overview: OverviewTab,
  acquisition: AcquisitionTab,
  channels: ChannelsTab,
  campaigns: CampaignsTab,
  revenue: RevenueTab,
  segments: SegmentsTab,
  customers: CustomersTab,
  rewards: RewardsAnalyticsTab,
  referral: ReferralTab,
  reviews: ReviewsTab,
  hours: HoursTab,
  operators: OperatorsTab,
  rfm: RfmTab,
  audit: AuditTab,
};

export default function AdminAnalytics() {
  const [tab, setTab] = useState('overview');
  const ActiveTab = TAB_COMPONENTS[tab] || OverviewTab;

  return (
    <div className="p-6 md:p-8 lg:p-10" data-testid="admin-analytics-page">
      <PageTooltip page="analytics" />
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-[#1A1A1A]">Analytics</h1>
      </div>
      <div className="flex gap-1.5 overflow-x-auto pb-2 mb-6 scrollbar-none" data-testid="analytics-tabs">
        {TABS.map(t => {
          const Icon = t.icon;
          return (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              data-testid={`tab-${t.id}`}
              className={`flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-medium whitespace-nowrap transition-all ${
                tab === t.id
                  ? 'bg-[#D44E20] text-white shadow-sm'
                  : 'text-[#64748B] hover:bg-slate-100 hover:text-[#1A1A1A]'
              }`}
            >
              <Icon size={13} />
              {t.label}
            </button>
          );
        })}
      </div>
      <ActiveTab />
    </div>
  );
}
